import styled from "styled-components"

export const UploadWrapper = styled.div`
    width: 13rem;
    height: 13rem;
    padding: 0 ${({ theme }) => theme.space.s};

    flex-shrink: 0;

    position: relative;

    border-radius: 50%;
    border: 1px solid
        ${({ isErr, isFile, theme }) => {
            if (isErr) return theme.color.warning
            if (isFile) return theme.color.blur
            return theme.color.focus
        }};

    label {
        width: 100%;
        font-size: ${({ theme }) => theme.font.size.m};

        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        display: flex;
        flex-direction: column;
        align-items: center;

        text-align: center;
        pointer-events: none;
        color: ${({ theme }) => theme.color.focus};

        & > i {
            margin-bottom: ${({ theme }) => theme.space.s};
        }
    }

    input {
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
    }
`



// WEBPACK FOOTER //
// ./src/OctoprintParser/FileUpload/styles.js